export enum ProgressionReducerActionTypes {
  Next = "NEXT",
  Back = "BACK",
  Jump_To = "JUMP_TO",
}

interface IProgressionActionGoNext {
  type: ProgressionReducerActionTypes.Next;
}

interface IProgressionActionGoBack {
  type: ProgressionReducerActionTypes.Back;
}

interface IProgressionActionJumpTo {
  type: ProgressionReducerActionTypes.Jump_To;
  value: number;
}

export type IProgressionAction =
  | IProgressionActionGoNext
  | IProgressionActionGoBack
  | IProgressionActionJumpTo;

export const progressionReducer = (
  state: number,
  action: IProgressionAction,
) => {
  switch (action.type) {
    case ProgressionReducerActionTypes.Next:
      return state + 1;
    case ProgressionReducerActionTypes.Back:
      return state - 1;
    case ProgressionReducerActionTypes.Jump_To:
      return action.value;
    default:
      return state;
  }
};
